// extracted by mini-css-extract-plugin
module.exports = {"Page":"idle-session-page_Page__n2QQG","PageContent":"idle-session-page_PageContent__fUF4u"};